import { useEffect, useRef, useState, useContext } from "react";
import "devextreme/data/odata/store";
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
  SearchPanel,
  Toolbar,
  Item,
  Paging,
} from "devextreme-react/data-grid";
import { SelectionChangedEvent } from "devextreme/ui/data_grid";
import { CheckBox } from "devextreme-react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  Badge
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { OidcIdentityContext } from "@rsmus/react-auth";
import { useRecoilValue } from "recoil";

import { calculateGridHeight, executeDownload, convertFormatDate } from "../../../util/Utils";
import { upgradeSiteClientApi } from "../../../api-client-nswag/taxportal-client-runtime";
import { SnackbarMessage, useSnackbar } from "../../../hooks";
import { defaultPageSize, UPGRADE_SITES_SCREENS } from "../../../constants";
import { CellRenderDate } from "../../../util/cellRendersAtoms";
import { SitesGridProps, constants, selectedOptionType } from "./UpgradeSitesGrids.types";
import "./UpgradeSites.scss";
import { ModalSiteChangesDetail } from "./ModalSiteChangesDetail";
import { getAppName } from "../../commonComponents/UpgradeSitesToggle";
import { IsUpgradeSiteMicroserviceEnabled } from "../../../envVariables";
import { DialogBox } from "../../../pages/CreateSites/DialogBox";
import { SiteComments } from "../../../pages/CreateSites/siteComments/siteComments";
import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Popover } from "@mui/material";
import "../../../pages/CreateFolders/CreateFolders.scss";

type DatagridRefType = DataGrid;

const {
  BUTTON_REVIEW_CHANGES,
  COLUMNS,
  BUTTON_DOWNLOAD_EXCEL,
  FILE_SITE_UPGRADE_NAME,
  ZIP_FILE_EXTENSION,
  BUTTON_BATCH_UPGRADE,
  BUTTON_RETRY_BATCHUPGRADE,
  BUTTON_UPGRADE_WITHOUT_COMPARISON,
    STATUSES
} = constants;
const {
  HQ_SITE_ID,
  ORG_ID,
  MDM_MASTER_CLIENT_ID,
  MDM_CLIENT_ID,
  NAME,
  TEMPLATE_NAME_OLD,
  TEMPLATE_NAME_NEW,
  UPGRADE_DATE,
  LAST_ACCESSED_DATE,
  UPGRADED_BY,
  STATUS,
  EXCLUDE_7216_CONSENT,
  CUSTOM_PERMISSION_APPLIED,
  COMMENTS,
  HAS_COMMENT,
} = COLUMNS;

const upgradeDropdownOptions = [
  BUTTON_UPGRADE_WITHOUT_COMPARISON,
  BUTTON_REVIEW_CHANGES,
    BUTTON_RETRY_BATCHUPGRADE
]

// Lookup data for Has Comment Y/N (matches CreateSite&SetUp pattern)
const hasCommentLookup = {
  dataSource: [
    { value: true, display: "Y" },
    { value: false, display: "N" },
  ],
  valueExpr: "value",
  displayExpr: "display",
};

// Custom header filter data for Yes/No with proper lookup
const yesNoHeaderFilterData = [
  { text: "Yes", value: ["exclude7216Consent", "=", true] },
  { text: "No", value: ["exclude7216Consent", "=", false] }
];

// Lookup data for Yes/No display
const yesNoLookup = {
  dataSource: [
    { value: true, text: "Yes" },
    { value: false, text: "No" }
  ],
  valueExpr: "value",
  displayExpr: "text"
};

export const SitesGrid = ({
  sitesData,
  selectedSites,
  setSelectedSites,
  setSelectedSitesData,
  dropDown,
  setDropDown,
  setSelectedTemplateLabel,
  fetchData,
  toggleSitesGrids,
  setPageNumber,
  searchTerm,
  setSearchTerm,
  setActiveScreen,
  toggleBatchUpgradeSitesGrids,
  batchGridData,
  setBatchGridData,
  IsBatchUpgrade,
  pageNumber,
  highlightComments,
  setHighlightComments,
  highlightCustomPermissions,
  setHighlightCustomPermissions,
}: SitesGridProps) => {
  const { user } = useContext(OidcIdentityContext);
  const userEmail = user?.profile.preferred_username!;
  const dataGridRef = useRef<DatagridRefType>(null);
  const { showSnackbar, showSuccessSnackbar } = useSnackbar();
    const [dropDownOptions, setDropDownOptions] = useState<selectedOptionType[]>([]);
  const count = Math.ceil(sitesData.totalCount / defaultPageSize);
  const areDropAndSiteSelected = !dropDown || !selectedSites.length;
  const [isDisplayModal, setIsDisplayModal] = useState(false);
  const [isDownloadEnabled, setIsDownloadEnabled] = useState(false);
  const [idUpgradeSiteTracks, setIdUpgradeSiteTracks] = useState<number>();
  const [modalHqSiteId, setModalHqSiteId] = useState<number>();
  const [isBatchUpgrade, setIsBatchUpgrade] = useState(false);
  const [isRetryBatchUpgrade, setIsRetryBatchUpgrade] = useState(false);
  const [isApplyButtonEnabled, setIsApplyButtonEnabled] = useState(false)
  const [upgradeOption, setUpgradeOption] = useState("");
  const [isCancelRequestEnabled, setIsCancelRequestEnabled] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [selectedRowData, setSelectedRowData] = useState<any>([]);
  const [selectedData, setSelectedData] = useState<any>([]);
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [commentCounts, setCommentCounts] = useState<{ [key: number]: number }>({},);
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(null);
  const [filterPosition, setFilterPosition] = useState<{ top: number; left: number } | null>(null);
  const prevKeysRef = useRef<any>([]);
  const prevDataRef = useRef<any>([]);
  const [goToPageInput, setGoToPageInput] = useState("");
  
  const appName = useRecoilValue(getAppName);
  const getDropDownOptions = async () => {
    try {
            const dropDownOpt = await upgradeSiteClientApi.highQ_GetHQSiteTemplate(appName);
      const dropOptions = dropDownOpt.map(({ id, sitename }) => ({
        value: id,
        label: sitename,
      }));
      setDropDownOptions(dropOptions);
        } catch (error) { }
  };


  const onSelectionchanged = (e: SelectionChangedEvent) => {
    const newPageKeys = e.selectedRowKeys;
    const newPageData = e.selectedRowsData;
        const visibleKeys = e.component.getVisibleRows().map((row: any) => row.key)

        const addedKeys = newPageKeys.filter((key: any) => !prevKeysRef.current.includes(key));
        const addedData = newPageData.filter((row: any) => addedKeys.includes(row.hqSiteId))
        const removedKeys = visibleKeys.filter((k: any) => prevKeysRef.current.includes(k) && !newPageKeys.includes(k))

    const updatedKeys = [
      ...prevKeysRef.current.filter((k: any) => !removedKeys.includes(k)),
      ...addedKeys,
        ]

    const updatedData = [
            ...prevDataRef.current.filter((row: any) => !removedKeys.includes(row.hqSiteId)),
      ...addedData,
        ]
    prevKeysRef.current = updatedKeys;
    prevDataRef.current = updatedData;

    setSelectedRowKeys(updatedKeys);
    setSelectedRowData(updatedData);
    }

  const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedRowData([]);
    setIsCancelRequestEnabled(false);
    prevKeysRef.current = [];
    prevDataRef.current = [];
  };



  const getSitesToDownload = () => {
    return selectedRowData.filter((site: any) => site.status !== null).map((siteData: any) => siteData.idUpgradeSiteTracks);
  };

  const refreshButtonOptions = {
    icon: "refresh",
    onClick: () => {
      clearSelection();
      fetchData();
    },
        hint: "Refresh"
  };

  const downloadButtonOptions = {
        icon: 'download',
    onClick: () => {
      handleExportButton();
    },
    hint: "Download Excel",
  };

  const handleOpenComments = (
    siteId: number,
    rowData: any,
    e: React.MouseEvent,
  ) => {
    e.stopPropagation();
    setSelectedData([rowData]);
    setIsCommentsOpen(true);
  };

  const handleCommentsClose = () => {
    setIsCommentsOpen(false);
    setSelectedData([]);
  };

  const renderCommentsCell = (cellInfo: any) => {
    const rowData = cellInfo?.row?.data;

    if (!rowData) return null;

    const siteId = rowData.hqSiteId;
    const count = commentCounts[siteId] || 0;

    return (
      <IconButton
        size="small"
        onClick={(e) => handleOpenComments(siteId, rowData, e)}
      >
        <Badge
          badgeContent={count}
        >
          <AddCommentOutlinedIcon/>
        </Badge>
      </IconButton>
    );
  };

  const exportButtonOptions = {
    icon: "exportxlsx",
    hint: "Export to Excel",
    onClick: async () => {
      try {
        await upgradeSiteClientApi
          .highQ_ExportToExcelForUpgradeSites(appName, null)
          .then((res: any) => {
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              appName + "-" + " Upgrade Sites Summary.xlsx"
            );
            link.click();
          });
        showSuccessSnackbar({
          message: SnackbarMessage.EXPORT_TO_EXCEL_SUCCESS,
        });
      } catch (error) {
        showSnackbar({
          message: SnackbarMessage.EXPORT_TO_EXCEL_FAIL,
          severity: "error",
        });
      }
    },
    elementAttr: {
      title: "Export to Excel",
    },
  };

  const handleSeeDetailsButton = (idUpgradeSiteTracks: number, hqSiteId: number) => {
    setIdUpgradeSiteTracks(idUpgradeSiteTracks);
    setModalHqSiteId(hqSiteId);
    setIsDisplayModal(true);
  };

  const handleClose = () => {
    setIdUpgradeSiteTracks(undefined);
    setModalHqSiteId(undefined);
    setIsDisplayModal(false);
  };

  const getSelectedData = () => {
    return selectedRowData || [];
  };
  const selectedRow = getSelectedData();

  const upgradeButtonEnables = (selectedRow: any) => {
    if (!selectedSites.length || !dropDown) {
      return false;
    }

    if (
      selectedRow.some(
                    (site: any) =>
                    (site.templateIdNew === null && site.templateIdOld === dropDown) || site.templateIdNew === dropDown
      )
    ) {
      return false;
    }

    if (selectedSites.length === 1) {
      return true;
    }
    let nullTemplates = [] as any[];
    let nonNullTemplates = [] as any[];
    selectedRow.forEach((site: any) => {
      if (site.templateNameNew === null) {
        nullTemplates.push(site);
      } else {
        nonNullTemplates.push(site);
      }
    });
    if (nullTemplates.length > 0 && nonNullTemplates.length > 0) {
      const isSameNonNullValue = nonNullTemplates.every(
                (site: any) => site.templateNameNew === nonNullTemplates[0].templateNameNew
      );

      const isSameNullValue = nullTemplates.every(
                (site: any) => site.templateNameOld === nullTemplates[0].templateNameOld
      );

      if (
        isSameNonNullValue &&
        isSameNullValue &&
        nonNullTemplates[0].templateNameNew === nullTemplates[0].templateNameOld
      ) {
        return true;
      }
    }
    if (nonNullTemplates.length > 0 && nullTemplates.length === 0) {
            return nonNullTemplates.every((site: any) => site.templateNameNew === nonNullTemplates[0].templateNameNew);
    }
    if (nullTemplates.length > 0 && nonNullTemplates.length === 0) {
            return nullTemplates.every((site: any) => site.templateNameOld === nullTemplates[0].templateNameOld);
    }
    return false;
  };

  const isButtonEnabled = upgradeButtonEnables(selectedRowData);
  const isMicroserviceEnabled = IsUpgradeSiteMicroserviceEnabled === "true";
  const isExportDisabled = sitesData?.totalCount === 0;

  const handleInitiateButton = () => {
    setSelectedSitesData(selectedRowData);
    setSelectedSites(selectedRowKeys);
    toggleSitesGrids(false);
    toggleBatchUpgradeSitesGrids(false);
    setActiveScreen(UPGRADE_SITES_SCREENS.SITES_SELECTED);
  };

  const getTargetLabel = (dropDown: string, dropDownOptions: any[]) => {
    return dropDownOptions.find((item) => item.value === dropDown);
  };

    const getTemplateData = (templates: any[], isNonNull: boolean, label: any) => {
    if (templates.length > 0 && isButtonEnabled) {
      const template = templates[0];
      return [
        {
                    latestTemplateName: isNonNull ? template.templateNameNew : template.templateNameOld,
                    latestTemplateId: isNonNull ? template.templateIdNew : template.templateIdOld,
          targetTemplateId: label?.value,
          targetTemplateName: label?.label,
        },
      ];
    }
    return [];
  };

    const batchData = (selectedRow: any[], dropDown: string, dropDownOptions: any[]) => {
    const label = getTargetLabel(dropDown, dropDownOptions);
        const nullTemplates = selectedRow.filter((site: any) => site.templateNameNew === null);
        const nonNullTemplates = selectedRow.filter((site: any) => site.templateNameNew !== null);

    if (nonNullTemplates.length > 0) {
      return getTemplateData(nonNullTemplates, true, label);
    } else if (nullTemplates.length > 0) {
      return getTemplateData(nullTemplates, false, label);
    }

    return [];
  };

  const handleInitiateBatchUpgradeButton = () => {
    setSelectedSitesData([]);
    setSelectedSites([]);
    setPageNumber(1);
    setActiveScreen(UPGRADE_SITES_SCREENS.BATCH_SITES_SELECTED);
    toggleBatchUpgradeSitesGrids(true);
    IsBatchUpgrade(true);

  };

  const handleDropDownChange = (e: SelectChangeEvent) => {
    const selectedValue = e.target.value;
    setDropDown(selectedValue);
    const selectedTemplate = dropDownOptions.find((item) => String(item.value) === String(selectedValue));
    setSelectedTemplateLabel(selectedTemplate?.label || "");
  };

  const handleUpgradeDropDownChange = (e: any) => {
        setUpgradeOption(e.target.value)
  };

  const onChangePagination = (e: any, nextPageNumber: number) => {
    if (nextPageNumber === pageNumber) {
      return;
    }
    setPageNumber(nextPageNumber);
  };

  const handleGoToPage = () => {
    const page = parseInt(goToPageInput, 10);
    if (!isNaN(page) && page >= 1 && page <= count) {
      onChangePagination(null, page);
    }
    setGoToPageInput("");
  };

  const renderDetails = ({ row: { data } }: any) => {
    const status = String(data?.status || "").trim().toUpperCase();

    return data.status && status !== "SCHEDULED" ? (
      <IconButton
        className="dx-datagrid dx-link"
        aria-label="See Details"
        title="See Details"
        onClick={() => handleSeeDetailsButton(data.idUpgradeSiteTracks, data.hqSiteId)}
      >
        <SearchIcon />
      </IconButton>
    ) : null;
  };

  const handleExportButton = async () => {
    showSnackbar({ message: SnackbarMessage.ZIP_UPGRADE_DOWNLOAD_MESSAGE });
    try {
      const sitesToDownload = getSitesToDownload();
            const base64String = await upgradeSiteClientApi.HQTemplateSiteUpgradeResultExcelExport(sitesToDownload);
            if (base64String) executeDownload(base64String, "", FILE_SITE_UPGRADE_NAME, ZIP_FILE_EXTENSION);
    } catch (error) {
            showSnackbar({ message: SnackbarMessage.ZIP_DOWNLOAD_FAILED, severity: "error" });
    }
  };

  const handleCancelRequest = async () => {
    const payload = selectedRowData.map((site: any) => Number(site.idUpgradeSiteTracks));

    try {
      const apiResults = await upgradeSiteClientApi.CancelScheduleUpgrade(userEmail, payload);
      if (apiResults) {
        clearSelection();
        fetchData();
      }
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };
  const handleRetryBatchUpgrade = async () => {
    try {
      const apiCalls = selectedRowData.map((record: any) =>
        upgradeSiteClientApi.taxPortal_RetryBatchUpgradeUpgradeSites(record.templateIdNew, record.hqSiteId, userEmail)
      );
    }
        catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
        }
        finally {

      fetchData();
    }
    }

    const handleUpgradeWithoutCompare = async () => {
      try {
        const apiResults = selectedRowData.map((record: any) =>
          upgradeSiteClientApi.taxPortal_UpgradeWithoutCompare(dropDown, record.hqSiteId, userEmail)
        );
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    } finally {

      fetchData();
    }
    }

  const handleApllyButton = () => {
    if (upgradeOption === BUTTON_REVIEW_CHANGES) {
      handleInitiateButton();
    } else if (upgradeOption === BUTTON_BATCH_UPGRADE) {
      handleInitiateBatchUpgradeButton();
    } else if (upgradeOption === BUTTON_RETRY_BATCHUPGRADE) {
      handleRetryBatchUpgrade();
    } else if (upgradeOption === BUTTON_UPGRADE_WITHOUT_COMPARISON) {
      handleUpgradeWithoutCompare();
    }
    }

  useEffect(() => {
    setSelectedSites(selectedRowKeys);
        const validStatuses = selectedRowData.filter((site: any) => site.status !== null);
        setIsDownloadEnabled(() => (selectedRowKeys.length && validStatuses.length ? true : false));
        const allSitesValidForRetry = selectedRowData.every((site: any) => site.status?.toLowerCase() === STATUSES.ERROR.toLowerCase() ||
            site.status?.toLowerCase() === STATUSES.PARTIALLY_SUCCESS.toLowerCase());
        setIsRetryBatchUpgrade(() => (selectedRowKeys.length > 0 && allSitesValidForRetry))

        const hasSelection = selectedRowKeys.length > 0;
        const isAllScheduled =
          hasSelection &&
          selectedRowData.every(
            (site: any) => String(site?.status || "").trim().toUpperCase() === "SCHEDULED"
          );
        setIsCancelRequestEnabled(isAllScheduled);
    }, [selectedRowKeys, selectedRowData])

  useEffect(() => {
    const hasBlockedStatusForInitiate = selectedRowData.some((site: any) => {
      const normalizedStatus = String(site?.status || "").replace(/\s+/g, "").toUpperCase();
      return normalizedStatus === "SCHEDULED" || normalizedStatus === "INPROGRESS";
    });

    if (upgradeOption === BUTTON_REVIEW_CHANGES) {
      setIsApplyButtonEnabled(!areDropAndSiteSelected && !hasBlockedStatusForInitiate);
    } else if (upgradeOption === BUTTON_BATCH_UPGRADE) {
      setIsApplyButtonEnabled(isButtonEnabled);
    } else if (upgradeOption === BUTTON_RETRY_BATCHUPGRADE) {
      setIsApplyButtonEnabled(isRetryBatchUpgrade);
    } else if (upgradeOption === BUTTON_UPGRADE_WITHOUT_COMPARISON) {
      setIsApplyButtonEnabled(!areDropAndSiteSelected && !hasBlockedStatusForInitiate);
    }
    }, [upgradeOption, isButtonEnabled, areDropAndSiteSelected, dropDown, selectedSites, selectedRowData, isRetryBatchUpgrade])


  useEffect(() => {
    clearSelection();
    setDropDown("");
    setSelectedTemplateLabel("");
    getDropDownOptions();
    }, [appName]);

  return (
    <div style={{ marginRight: "20px" }}>
      <div className="counter">
        <h4>
          {sitesData.pending
                        ? "Loading..." : `${selectedSites.length} out of ${sitesData.totalCount} records selected`}
        </h4>
      </div>

      <DataGrid
        id="grid-sites"
        ref={dataGridRef}
        keyExpr="hqSiteId"
        allowColumnResizing
        dataSource={sitesData.sites}
        showBorders
        onSelectionChanged={onSelectionchanged}
        height={calculateGridHeight(260)}
        remoteOperations
        noDataText={sitesData.pending ? "Loading..." : "No Data"}
        selectedRowKeys={selectedRowKeys}
        onRowPrepared={(e) => {
          if (e.rowType !== "data") return;
          if (highlightComments && e.data?.hasComment) {
            e.rowElement.style.backgroundColor = "#ffffcc";
          } else if (highlightCustomPermissions && e.data?.isCustomPermissionApplied) {
            e.rowElement.style.backgroundColor = "#ffffcc";
          } else {
            e.rowElement.style.backgroundColor = "";
          }
        }}
      >
                <Selection mode="multiple" selectAllMode={"page"} showCheckBoxesMode={"always"} />
        <Scrolling columnRenderingMode="virtual" />
        <FilterRow visible />
        <HeaderFilter visible />
        <SearchPanel
          placeholder={"Global Search..."}
          width={160}
          onTextChange={(e) => {
            setSearchTerm(e);
          }}
          visible
        />
        <Paging enabled={false} />
        <Toolbar>
          <Item location="start">
            <FormControl size="medium" variant="outlined" sx={{ width: 168 }}>
              <FormLabel className="form-label">Select a Template</FormLabel>
              <Select
                style={{ height: 36, fontSize: "14px" }}
                defaultValue={dropDown}
                onChange={handleDropDownChange}
                MenuProps={{
                  style: {
                    maxHeight: 300,
                  },
                }}
              >
                {dropDownOptions.map(({ value, label }) => (
                                    <MenuItem key={value} value={value} style={{ fontSize: "14px" }}>
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Item>


          <Item location="start">
            <FormControl size="medium" variant="outlined" sx={{ width: 220 }}>
                            <FormLabel className="form-label">Select Upgrade Options</FormLabel>
              <Select
                style={{ height: 36, fontSize: "14px" }}
                defaultValue={upgradeOption}
                onChange={handleUpgradeDropDownChange}
                MenuProps={{
                  style: {
                    maxHeight: 300,
                  },
                }}
              >
                {upgradeDropdownOptions.map((option) => (
                                    <MenuItem key={option} value={option} style={{ fontSize: "14px" }}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Item>
          <Item location="start">
            <Button
              variant="outlined"
              sx={{ minWidth: 80, whiteSpace: "nowrap" }}
              disabled={!isApplyButtonEnabled}
              onClick={() => {
                handleApllyButton();
              }}
            >
              Apply
            </Button>
          </Item>
          <Item location="start">
            <Button
              variant="outlined"
              sx={{ minWidth: 160, whiteSpace: "nowrap" }}
              onClick={handleInitiateBatchUpgradeButton}
            >
              {BUTTON_BATCH_UPGRADE}
            </Button>
          </Item>
          <Item location="start">
            <Button
              variant="outlined"
              disabled={!isCancelRequestEnabled}
              onClick={handleCancelRequest}
              sx={{ minWidth: 150, whiteSpace: "nowrap", ml: 0, mr: 0, flexShrink: 0 }}
            >
              Cancel Request
            </Button>
          </Item>
          {isMicroserviceEnabled && (
            <Item
              widget="dxButton"
              options={exportButtonOptions}
              location="after"
              disabled={isExportDisabled}
            />
          )}
          <Item name="searchPanel" location="after" />
          <Item location="after">
            <IconButton
              size="medium"
              title="Filter"
              onClick={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                setFilterPosition({ top: rect.bottom + 4, left: rect.left });
                setFilterAnchorEl(e.currentTarget);
              }}
              color={(highlightComments || highlightCustomPermissions) ? "primary" : "default"}
              className={(highlightComments || highlightCustomPermissions) ? "filter-icon-btn--active" : "filter-icon-btn"}
            >
              <Badge
                badgeContent={[highlightComments, highlightCustomPermissions].filter(Boolean).length || undefined}
                color="primary"
              >
                <FilterAltIcon fontSize="medium" />
              </Badge>
            </IconButton>
          </Item>
                    <Item widget="dxButton" options={downloadButtonOptions} location="after" disabled={!isDownloadEnabled} />
                    <Item widget="dxButton" options={refreshButtonOptions} location="after" />
        </Toolbar>
                <Column dataField="hqSiteId" caption={HQ_SITE_ID} minWidth={70} alignment="left" />
                <Column dataField="orgId" caption={ORG_ID} minWidth={135} alignment="left" />
                <Column dataField="mdmMasterClientId" caption={MDM_MASTER_CLIENT_ID} minWidth={135} alignment="left" />
                <Column dataField="mdmClientId" caption={MDM_CLIENT_ID} minWidth={100} alignment="left" />
                <Column minWidth={300} dataField="name" caption={NAME} alignment="left" />
                <Column caption={COMMENTS} minWidth={100} alignment="center" cellRender={renderCommentsCell}/>
                <Column
                  dataField="hasComment"
                  caption={HAS_COMMENT}
                  minWidth={120}
                  alignment="center"
                  lookup={hasCommentLookup}
                />
                <Column
                  dataField="isCustomPermissionApplied"
                  caption={CUSTOM_PERMISSION_APPLIED}
                  width={140}
                  alignment="center"
                  filterValue={null}
                  calculateFilterExpression={(filterValue: any) => {
                    if (filterValue === false) {
                      return [
                        ["isCustomPermissionApplied", "=", false],
                        "or",
                        ["isCustomPermissionApplied", "=", null],
                      ];
                    }
                    return ["isCustomPermissionApplied", "=", filterValue];
                  }}
                  cellRender={(rowData) => (
                    <CheckBox
                      value={!!rowData.data.isCustomPermissionApplied}
                      elementAttr={{
                        style: "pointer-events: none; opacity: 1;",
                      }}
                    />
                  )}
                />
                <Column minWidth={300} dataField="templateNameOld" caption={TEMPLATE_NAME_OLD} alignment="left" />
                <Column minWidth={300} dataField="templateNameNew" caption={TEMPLATE_NAME_NEW} alignment="left" />
                <Column 
                      minWidth={300} 
                      dataField="exclude7216Consent" 
                      caption={EXCLUDE_7216_CONSENT} 
                      alignment="left"
                      lookup={yesNoLookup}
                    >
                    <HeaderFilter dataSource={yesNoHeaderFilterData} />
                </Column>
        <Column
          cellRender={({ data }) => CellRenderDate(data.upgradeDate)}
          dataField="upgradeDate"
          caption={UPGRADE_DATE}
          minWidth={180}
          alignment="left"
        />
                <Column dataField="upgradeBy" caption={UPGRADED_BY} minWidth={180} alignment="left" />
                <Column dataField="status" caption={STATUS} minWidth={180} alignment="left" />
                <Column
                  cellRender={({ data }) => <div>{convertFormatDate(data.siteLastAccessed, "MMM Do YY")}</div>}
                  calculateCellValue={({ siteLastAccessed }: { siteLastAccessed: string }) => convertFormatDate(siteLastAccessed, "MMM Do YY")}
                  dataField="siteLastAccessed"
                  caption={LAST_ACCESSED_DATE}
                  minWidth={180}
                  alignment="left"
                >
                  <HeaderFilter dataSource={(options: any) => {
                    options.dataSource.postProcess = (data: any[]) =>
                      data.map((item: any) => ({
                        ...item,
                        text: item.value ? convertFormatDate(item.value, "MMM Do YY") : "(Blanks)",
                      }));
                  }} />
                </Column>
                <Column cellRender={renderDetails} type="buttons" caption="Changes detail" />
      </DataGrid>
      <div className="grid-pagination">
        <Pagination onChange={onChangePagination} page={pageNumber} count={count} variant="outlined" shape="rounded" />
        <div className="go-to-page">
          <span>Go to page</span>
          <input
            className="go-to-page-input"
            type="text"
            value={goToPageInput}
            onChange={(e) => setGoToPageInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleGoToPage(); }}
            onBlur={handleGoToPage}
            placeholder={String(pageNumber)}
          />
        </div>
      </div>
      <ModalSiteChangesDetail
        handleClose={handleClose}
        isDisplayModal={isDisplayModal}
        idUpgradeSiteTracks={idUpgradeSiteTracks}
        hqSiteId={modalHqSiteId}
        userEmail={userEmail}
      />
      <DialogBox
        isDisplayModal={isCommentsOpen}
        handleClose={handleCommentsClose}
        title={"Site Comments"}
        btnContinueDisable={true}
      >
        {selectedData.length > 0 ? (
          <SiteComments
            selectedRowData={selectedData[0]}
            commentSource="UpgradeSite"
          />
        ) : (
          <></>
        )}
      </DialogBox>
      <Popover
        open={Boolean(filterPosition)}
        anchorEl={filterAnchorEl}
        onClose={() => { setFilterPosition(null); setFilterAnchorEl(null); }}
        anchorReference="anchorPosition"
        anchorPosition={filterPosition ?? { top: 0, left: 0 }}
      >
        <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: "6px", minWidth: 260 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={highlightComments}
                onChange={(e) => {
                  setHighlightComments(e.target.checked);
                  dataGridRef.current?.instance.repaint();
                }}
                size="small"
              />
            }
            label="Display sites with comments"
            sx={{ margin: 0, "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={highlightCustomPermissions}
                onChange={(e) => {
                  setHighlightCustomPermissions(e.target.checked);
                  dataGridRef.current?.instance.repaint();
                }}
                size="small"
              />
            }
            label="Display sites with custom permissions"
            sx={{ margin: 0, "& .MuiFormControlLabel-label": { fontSize: "13px" } }}
          />
          <Button
            size="small"
            variant="outlined"
            disabled={!highlightComments && !highlightCustomPermissions}
            onClick={() => {
              setHighlightComments(false);
              setHighlightCustomPermissions(false);
              dataGridRef.current?.instance.repaint();
              setFilterPosition(null);
              setFilterAnchorEl(null);
            }}
            style={{ marginTop: 4 }}
          >
            Clear Filter
          </Button>
        </div>
      </Popover>
    </div>
  );
};
